'use strict';

var analyticsHelper = require('app_honda_cars/utils/analyticsHelper');
var configuratorHelpers = require('./configuratorHelpers');

function getFinanceSelectedModels() {
    var summaryDataJSON = $('.js-save-summary').attr('data-car-summary-data');
    if (!summaryDataJSON) {
        return { model: '', grade: '', model_id: '' };
    }
    var summaryData = JSON.parse(summaryDataJSON);
    var productData = summaryData.data.product;
    var model = (productData.productName || '').replace(/^\d{4}\s+/, '');
    return {
        model: model,
        grade: productData.customProps.grade || '',
        model_id: productData.id || ''
    };
}

// ─── Redesign flyout finance helpers ────────────────────────────────────────────
// Schema only. When each step fires is owned by product/navigation/applyForFinance.js,
// which bridges here with the flyout form as `data.$form`.

function getFlyoutFinanceCentre($form) {
    var $centre = $form ? $form.find('.selected-honda-centre').first() : $();
    if (!$centre.length) {
        var loc = configuratorHelpers.getConfiguratorLocation();
        return { dealer: loc.dealerName, location: loc.formattedAddress, postcode: loc.postalCode };
    }
    return {
        dealer: $centre.find('.name').text().trim(),
        location: $centre.find('.address').text().trim(),
        postcode: $centre.find('input[name="AddressPostcode"]').val() || ''
    };
}

function buildFlyoutFinanceData($form) {
    var centre = getFlyoutFinanceCentre($form);
    // configurator.js seeds window.globalSaveuniqueCode = {} (truthy); only accept a real string code.
    var configuratorId = (typeof window.globalSaveuniqueCode === 'string') ? window.globalSaveuniqueCode : '';
    return {
        'configurator ID': configuratorId,
        'location': centre.location,
        'postcode': centre.postcode,
        'dealer': centre.dealer
    };
}

function buildFlyoutFinanceModels() {
    try {
        var accessoriesData = [];
        var accessoriesJSONData = $('.accessory-product-data').attr('data-accessory-product-data');
        var ecommerceData = accessoriesJSONData ? JSON.parse(accessoriesJSONData).ecommerce : null;
        if (ecommerceData && Array.isArray(ecommerceData.items)) {
            // items[0] is the vehicle itself.
            for (var i = 1; i < ecommerceData.items.length; i++) {
                var item = ecommerceData.items[i];
                accessoriesData.push({
                    accessory_id: item.item_id || '',
                    accessory_name: item.item_name || '',
                    accessory_category: item.item_category || '',
                    accessory_sub_category: item.item_category2 || ''
                });
            }
        }
        var productData = JSON.parse($('.js-save-summary').attr('data-car-summary-data')).data.product;
        return [configuratorHelpers.buildConfiguratorSelectedModel(productData, accessoriesData)];
    } catch (e) {
        return [];
    }
}

function pushFlyoutFinanceStep(action, $form, extra) {
    window.dataLayer.push($.extend({
        event: 'custom.form',
        group: 'Apply for Finance',
        category: 'configurator',
        action: action,
        userRequestId: window.applyFinanceUUID || null,
        data: buildFlyoutFinanceData($form),
        models: buildFlyoutFinanceModels()
    }, extra || {}));
}

var events = {

    sidebarFinanceOptions: function (data) {
        dataLayer.push({
            'event': 'custom.menu',
            'group': 'side navigation menu',
            'category': 'side navigation',
            'action': 'click',
            'label': data.text().trim()
        });
    },

    customizeFinanceCTA: function (data) {
        var financeModels = getFinanceSelectedModels();
        dataLayer.push({
            event: 'click_cta',
            action: 'click',
            content_type: 'configurator',
            location: data.location,
            link_text: data.linkText,
            cta_type: data.ctaType || 'customize_finance',
            model: financeModels.model,
            grade: financeModels.grade,
            model_id: financeModels.model_id || null,
            ui_experience: 'configurator',
            timestamp_unix: Math.floor(Date.now() / 1000)
        });
    },

    applyForFinanceViewForm: function (data) {
        var financeModels = getFinanceSelectedModels();
        window.applyFinanceUUID = crypto.randomUUID();
        var financeUUID = window.applyFinanceUUID;

        var loc = configuratorHelpers.getConfiguratorLocation();
        var summaryDataJSON = $('.js-save-summary').attr('data-car-summary-data');
        var accessoriesJSONData = $('.accessory-product-data').attr('data-accessory-product-data');
        var accessoriesData = [];
        if (accessoriesJSONData) {
            var ecommerceData = JSON.parse(accessoriesJSONData).ecommerce;
            if (ecommerceData && Array.isArray(ecommerceData.items)) {
                for (var i = 1; i < ecommerceData.items.length; i++) {
                    var item = ecommerceData.items[i];
                    accessoriesData.push({
                        accessory_id: item.item_id || '',
                        accessory_name: item.item_name || '',
                        accessory_category: item.item_category || '',
                        accessory_sub_category: item.item_category2 || ''
                    });
                }
            }
        }
        var productData = JSON.parse(summaryDataJSON).data.product;
        var selectedModel = configuratorHelpers.buildConfiguratorSelectedModel(productData, accessoriesData);
        var financeDataObj = {
            'configurator ID': window.globalSaveuniqueCode || '',
            'location': loc.formattedAddress,
            'postcode': loc.postalCode,
            'dealer': loc.dealerName
        };
        var financeModelsArr = [selectedModel];

        dataLayer.push({
            event: 'form.view',
            form_name: 'apply for finance',
            action: 'view',
            content_type: 'configurator',
            location_onpage: 'sub_navigation',
            model: financeModels.model,
            grade: financeModels.grade,
            model_id: financeModels.model_id,
            userRequestId: financeUUID
        });
        dataLayer.push({
            event: 'custom.form',
            group: 'Apply for Finance',
            category: 'configurator',
            action: 'view',
            userRequestId: financeUUID,
            model: financeModels.model,
            grade: financeModels.grade,
            model_id: financeModels.model_id,
            data: financeDataObj,
            models: financeModelsArr
        });

        var $financeForm = data && data.length ? data : $('.summary-apply-for-finance-form');
        $financeForm.off('change.p2Finance').on('change.p2Finance', 'input, select, textarea', function () {
            if (analyticsHelper.isFirstFormInteraction('p2_finance')) {
                var fm = getFinanceSelectedModels();
                dataLayer.push({
                    event: 'custom.form',
                    group: 'Apply for Finance',
                    category: 'configurator',
                    action: 'start',
                    userRequestId: financeUUID,
                    model: fm.model,
                    grade: fm.grade,
                    model_id: fm.model_id,
                    data: financeDataObj,
                    models: financeModelsArr
                });
            }
            var fieldName = $(this).attr('name') || $(this).attr('id') || '';
            var fm2 = getFinanceSelectedModels();
            dataLayer.push({
                event: 'custom.form',
                group: 'Apply for Finance',
                category: 'configurator',
                action: 'interaction',
                field_name: fieldName,
                field_value: analyticsHelper.getPIISafeValue(fieldName, $(this).val()),
                userRequestId: financeUUID,
                model: fm2.model,
                grade: fm2.grade,
                model_id: fm2.model_id,
                data: financeDataObj,
                models: financeModelsArr
            });
        });
    },

    applyForFinanceSubmitForm: function (data) {
        var financeModels = getFinanceSelectedModels();
        var $form = $('.summary-apply-for-finance-form');

        if (!window.applyFinanceUUID) {
            window.applyFinanceUUID = crypto.randomUUID();
        }

        var loc = configuratorHelpers.getConfiguratorLocation();
        var summaryDataJSON = $('.js-save-summary').attr('data-car-summary-data');
        var accessoriesJSONData = $('.accessory-product-data').attr('data-accessory-product-data');
        var accessoriesData = [];
        if (accessoriesJSONData) {
            var ecommerceData = JSON.parse(accessoriesJSONData).ecommerce;
            if (ecommerceData && Array.isArray(ecommerceData.items)) {
                for (var i = 1; i < ecommerceData.items.length; i++) {
                    var item = ecommerceData.items[i];
                    accessoriesData.push({
                        accessory_id: item.item_id || '',
                        accessory_name: item.item_name || '',
                        accessory_category: item.item_category || '',
                        accessory_sub_category: item.item_category2 || ''
                    });
                }
            }
        }
        var productData = JSON.parse(summaryDataJSON).data.product;
        var selectedModel = configuratorHelpers.buildConfiguratorSelectedModel(productData, accessoriesData);
        var financeDataObj = {
            'configurator ID': window.globalSaveuniqueCode || '',
            'location': loc.formattedAddress,
            'postcode': loc.postalCode,
            'dealer': loc.dealerName
        };
        var financeModelsArr = [selectedModel];

        analyticsHelper.hashUserData(analyticsHelper.extractFormPII($form)).then(function (userData) {
            dataLayer.push({
                event: 'form_submit',
                form_name: 'apply for finance',
                action: 'complete',
                content_type: 'configurator',
                location_onpage: 'sub_navigation',
                model: financeModels.model,
                grade: financeModels.grade,
                model_id: financeModels.model_id,
                userRequestId: window.applyFinanceUUID || null,
                timeSpent: analyticsHelper.getTimeSpent(),
                userData: userData,
                data: financeDataObj,
                models: financeModelsArr
            });
        });
    },

    summaryApplyForFinanceForm: function () {
        var loc = configuratorHelpers.getConfiguratorLocation();
        var summaryDataJSON = $('.js-save-summary').attr('data-car-summary-data');
        var accessoriesJSONData = $('.accessory-product-data').attr('data-accessory-product-data');
        var accessoriesData = [];
        if (accessoriesJSONData) {
            var ecommerceData = JSON.parse(accessoriesJSONData).ecommerce;
            if (ecommerceData && Array.isArray(ecommerceData.items)) {
                for (var i = 1; i < ecommerceData.items.length; i++) {
                    var item = ecommerceData.items[i];
                    accessoriesData.push({
                        accessory_id: item.item_id || '',
                        accessory_name: item.item_name || '',
                        accessory_category: item.item_category || '',
                        accessory_sub_category: item.item_category2 || ''
                    });
                }
            }
        }
        var productData = JSON.parse(summaryDataJSON).data.product;
        var selectedModel = configuratorHelpers.buildConfiguratorSelectedModel(productData, accessoriesData);

        if (analyticsHelper.isFirstFormInteraction('applyForFinance')) {
            dataLayer.push({
                'event': 'custom.form',
                'group': 'Apply for Finance',
                'category': 'configurator',
                'action': 'start',
                'userRequestId': window.applyFinanceUUID || null,
                'data': {
                    'configurator ID': window.globalSaveuniqueCode || '',
                    'location': loc.formattedAddress,
                    'postcode': loc.postalCode,
                    'dealer': loc.dealerName
                },
                models: [selectedModel]
            });
        }
    },

    // Redesign flyout finance form steps, bridged from applyForFinance.js (data = { $form, … }).
    configuratorFinanceFormView: function (data) {
        pushFlyoutFinanceStep('view', data && data.$form);
    },

    configuratorFinanceFormStart: function (data) {
        pushFlyoutFinanceStep('start', data && data.$form);
    },

    configuratorFinanceFormInteraction: function (data) {
        pushFlyoutFinanceStep('interaction', data.$form, {
            field_name: data.fieldName,
            field_value: analyticsHelper.getPIISafeValue(data.fieldName, data.fieldValue)
        });
    },

    summaryApplyForFinance: function (data) {
        var loc = configuratorHelpers.getConfiguratorLocation();
        var summaryDataJSON = $('.js-save-summary').attr('data-car-summary-data');
        var accessoriesJSONData = $('.accessory-product-data').attr('data-accessory-product-data');
        var accessoriesData = [];
        if (accessoriesJSONData) {
            var ecommerceData = JSON.parse(accessoriesJSONData).ecommerce;
            if (ecommerceData && Array.isArray(ecommerceData.items)) {
                for (var i = 1; i < ecommerceData.items.length; i++) {
                    var item = ecommerceData.items[i];
                    accessoriesData.push({
                        accessory_id: item.item_id || '',
                        accessory_name: item.item_name || '',
                        accessory_category: item.item_category || '',
                        accessory_sub_category: item.item_category2 || ''
                    });
                }
            }
        }
        var productData = JSON.parse(summaryDataJSON).data.product;
        var selectedModel = configuratorHelpers.buildConfiguratorSelectedModel(productData, accessoriesData);
        var financeDataObj = {
            'configurator ID': window.globalSaveuniqueCode || '',
            'location': loc.formattedAddress,
            'postcode': loc.postalCode,
            'dealer': loc.dealerName
        };

        window.applyFinanceUUID = crypto.randomUUID();
        var financeUUID = window.applyFinanceUUID;

        dataLayer.push({
            'event': 'custom.cta',
            'group': 'Apply for Finance',
            'category': 'configurator',
            'action': 'click',
            'label': data.text().trim() + ' And Share'
        });
        dataLayer.push({
            'event': 'custom.form',
            'group': 'Apply for Finance',
            'category': 'configurator',
            'action': 'view',
            'userRequestId': financeUUID,
            'data': financeDataObj,
            models: [selectedModel]
        });

        var startFired = false;
        $('.summary-apply-for-finance-form').off('change.p2FinanceSummary').on('change.p2FinanceSummary', 'input, select, textarea', function () {
            if (!startFired) {
                startFired = true;
                dataLayer.push({
                    'event': 'custom.form',
                    'group': 'Apply for Finance',
                    'category': 'configurator',
                    'action': 'start',
                    'userRequestId': financeUUID,
                    'data': financeDataObj,
                    models: [selectedModel]
                });
            }
            var fieldName = $(this).attr('name') || $(this).attr('id') || '';
            dataLayer.push({
                'event': 'custom.form',
                'group': 'Apply for Finance',
                'category': 'configurator',
                'action': 'interaction',
                'field_name': fieldName,
                'field_value': analyticsHelper.getPIISafeValue(fieldName, $(this).val()),
                'userRequestId': financeUUID,
                'data': financeDataObj,
                models: [selectedModel]
            });
        });
    }
};

function init() {
    $('body').on('click', '#sidebar-finance-options', function () {
        $('body').trigger('gtm:event', { callback: 'sidebarFinanceOptions', data: $(this) });
    });

    $('body').on('click', '.configurator-footer-actions-view-repayments, .configurator-footer__bar', function () {
        $('body').trigger('gtm:event', {
            callback: 'customizeFinanceCTA',
            data: {
                location: 'customise finance card',
                linkText: $('.configurator-footer-actions-view-repayments').hasClass('collapsed')
                    ? 'expand finance tray' : 'collapse finance tray'
            }
        });
    });

    $('body').on('click', '.summary-apply-for-finance-cta-info-customize', function () {
        $('body').trigger('gtm:event', { callback: 'customizeFinanceCTA', data: { location: 'customise finance card', linkText: 'Apply for finance' } });
    });

    $('body').on('click', '.summary-apply-for-finance-cta-info-customize-bottom', function () {
        $('body').trigger('gtm:event', { callback: 'customizeFinanceCTA', data: { location: 'customise finance bottom', linkText: 'Apply for finance' } });
    });

    $('body').on('click', '.summary-apply-for-finance-cta-info-summaryPage-DesktopView-finance', function () {
        $('body').trigger('gtm:event', { callback: 'customizeFinanceCTA', data: { location: 'summary finance', linkText: 'Apply for finance' } });
    });

    $('body').on('click', '.summary-apply-for-finance-cta-info-summaryPage-mobileView-finance', function () {
        $('body').trigger('gtm:event', { callback: 'customizeFinanceCTA', data: { location: 'summary finance', linkText: 'Apply for finance' } });
    });

    $('body').on('click', '.summary-apply-for-finance-cta', function () {
        var $el = $(this);
        setTimeout(function () {
            $('body').trigger('gtm:event', { callback: 'summaryApplyForFinance', data: $el });
        }, 2000);
    });

    $('body').on('click', '.summary-apply-for-finance-cta-applyNow', function () {
        $('body').trigger('gtm:event', { callback: 'customizeFinanceCTA', data: { location: 'finance modal', linkText: 'Apply now' } });
    });

    $('body').on('click', '.summary-apply-finance-details-submit', function () {
        $('body').trigger('gtm:event', { callback: 'applyForFinanceSubmitForm', data: $(this) });
    });
}

module.exports = { init: init, events: events };
